import { ChangeDetectionStrategy, Component, computed, input, output } from '@angular/core'
import type { FileService } from '@awork/_shared/services/file-service/file.service'
import { FileDropComponent } from '../file-drop/file-drop.component'
import { TruncatePipe } from '../../../pipes/truncate/truncate.pipe'
import type { ValidFileEntities, ValidFileEntityTypes } from '@awork/_shared/services/file-service/types'
import replace from '@awork/_shared/functions/replace'

@Component({
  selector: 'aw-entity-file-drop',
  templateUrl: './entity-file-drop.component.html',
  styleUrls: ['./entity-file-drop.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [FileDropComponent]
})
export class EntityFileDropComponent {
  readonly entity = input<ValidFileEntities>()
  readonly entityType = input<ValidFileEntityTypes>()
  readonly fileService = input<FileService>()

  readonly onFilesDropped = output<void>()

  private readonly truncatePipe = new TruncatePipe()
  protected readonly fileDropTranslations = q.translations.FileDropComponent

  protected readonly subtitle = computed(() =>
    replace(this.fileDropTranslations.attachFiles, {
      entityName: this.truncatePipe.transform(this.entity().name)
    })
  )

  attachmentFiles: File[] = []
  uploadError = ''
  isDraggingOver = false

  /**
   * Callback triggered when the file is dropped on the overlay
   * @param {File[]} files
   */
  filesDropped(files: File[]): void {
    files?.forEach(attachment => {
      this.fileService().sendEntityFile(this.entityType(), this.entity(), attachment).subscribe()
    })

    this.onFilesDropped.emit()
  }
}
